<template>
  <footer class="footer-custom align-middle">
    <div class="text-box">
      <img
        class="line-logo"
        src="../assets/new_ui/pngegg@3x.png"
        alt="Letmein LOGO"
      />
      <div class="line-text">
        <div>ติดต่อสอบถามได้ที่</div>
        <div>@letmein.care</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponents",
};
</script>

<style>
.footer-custom {
  display: flex;
  justify-content: space-between;
  background-color: #ffff;
  padding: 15px 25px;
  height: 60px;
}

.footer-custom .image-box {
  width: 140px;
  height: 30px;
}

.footer-custom .logo-img {
  width: 100%;
  height: 100%;
}

.footer-custom .line-logo {
  width: auto;
  height: 100%;
}

.footer-custom .text-box {
  padding: 2px 0px;
  display: flex;
}

.footer-custom .line-text {
  margin-left: 4px;
  color: #3f4855;
  font-size: 10px;
  font-weight: light;
}
</style>
